var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27415 4.40299V8.40299L10.9408 9.73633M14.9408 8.40299C14.9408 12.0849 11.956 15.0697 8.27415 15.0697C4.59225 15.0697 1.60748 12.0849 1.60748 8.40299C1.60748 4.7211 4.59225 1.73633 8.27415 1.73633C11.956 1.73633 14.9408 4.7211 14.9408 8.40299Z",
    stroke: "#475569",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e11e490618e0465ea7333f8865e8afec.svg";
export { ForwardRef as ReactComponent };